<template>
    <stay-marquis-logo />
</template>

<script type="text/javascript">
    import StayMarquisLogo from '@/assets/logos/staymarquis.svg.vue';

    export default {

        components: {
            StayMarquisLogo,
        },
        
    };

</script>